import { render, staticRenderFns } from "./JobDescriptionsPage.vue?vue&type=template&id=9bc6e7fa&"
import script from "./JobDescriptionsPage.vue?vue&type=script&lang=js&"
export * from "./JobDescriptionsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports